import Script from 'next/script'
import { useConsentManager } from '@/utils/consent/ConsentInfoProvider'

const OutbrainScript = () => {
    const { consentInfo } = useConsentManager()
    if (consentInfo?.consent_info !== 'on') return null
    return (
        <Script
            id="gtm_outbrain"
            strategy="afterInteractive"
            async
            src="https://widgets.outbrain.com/outbrain.js"
        />
    )
}

export default OutbrainScript
